<template>
  <div>
    <v-btn color="primary" dark class="mb-2" @click="openCreateModal">
      代理店マージンの追加
    </v-btn>
    <SearchBarWithCheckbox
      class="mt-2"
      :keyword="filterKeyword"
      :checkbox="showNewItem"
      :search-result="searchResult"
      placeholder="代理店名・名称"
      @inputKeyword="filterKeyword = $event"
      @inputCheckbox="showNewItem = $event"
      @pagination="pagination"
      @search="$emit('search', $event)"
    />
    <v-data-table
      :headers="headers"
      :items="agencyMarginList"
      :loading="loading"
      hide-actions
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="pr-0">
          <v-switch
            v-if="props.item.isRequestPassed"
            v-model="props.item.isStatusActive"
            class="mt-3"
            @click.prevent.stop="openConfirmModal(props.item)"
          />
        </td>
        <td class="text-xs-left">
          <v-btn
            v-if="props.item.canChangeRequest"
            small
            color="primary"
            class="mx-0"
            @click="openEditModal(props.item)"
          >
            変更申請
          </v-btn>
        </td>
        <td class="text-xs-left no-wrap">
          <span :class="{ 'not-passed-record': !props.item.isRequestPassed }">
            {{ props.item.agencyName }}
          </span>
        </td>
        <td class="text-xs-left no-wrap">
          <span :class="{ 'not-passed-record': !props.item.isRequestPassed }">
            {{ props.item.displayData.name }}
          </span>
        </td>
        <td class="text-xs-left">
          <span :class="{ 'not-passed-record': !props.item.isRequestPassed }">
            {{ props.item.displayData.marginPercent }}
          </span>
        </td>
        <td class="text-xs-left no-wrap">
          <span :class="{ 'not-passed-record': !props.item.isRequestPassed }">
            {{ props.item.displayData.dateRange }}
          </span>
        </td>
        <td class="text-xs-left no-wrap memo-area">
          <span :class="{ 'not-passed-record': !props.item.isRequestPassed }">
            {{ props.item.displayData.note }}
          </span>
        </td>
        <td class="text-xs-left no-wrap">
          <div v-if="props.item.hasLatestRequest">
            <RequestDescription
              :status="props.item.latestRequest.requestStatus"
              :type="props.item.requestType"
              :class="{ 'not-passed-record': !props.item.isRequestPassed }"
              @click="openLatestRequestDetailModal(props.item)"
            />
          </div>
        </td>
        <td class="text-xs-left">
          <v-btn
            small
            color="primary"
            class="mx-0"
            @click="openDetailModal(props.item)"
          >
            詳細
          </v-btn>
        </td>
      </template>
      <template slot="no-data">
        <div>登録されている代理店マージンはありません</div>
      </template>
    </v-data-table>
    <CreateModal v-model="isActiveCreateModal" />
    <DetailModal
      v-model="isActiveDetailModal"
      :item="currentItem"
      @cancelRequest="$emit('cancelRequest', $event)"
    />
    <LatestRequestModal
      v-model="isActiveLatestRequestModal"
      :item="currentItem && currentItem.latestRequest"
    />
    <EditModal v-model="isActiveEditModal" :item="currentItem" />
  </div>
</template>

<script>
import RequestDescription from '../../Shared/Presentation/Request/RequestDescription.vue'
import CreateModal from './EditAgencyMarginCreateModal'
import LatestRequestModal from './EditAgencyMarginLatestRequestModal'
import DetailModal from './EditAgencyMarginDetailModal'
import EditModal from './EditAgencyMarginEditModal'
import SearchBarWithCheckbox from '@/components/Shared/Search/SearchBarWithCheckbox'

export default {
  components: {
    CreateModal,
    DetailModal,
    EditModal,
    LatestRequestModal,
    RequestDescription,
    SearchBarWithCheckbox,
  },
  props: {
    searchResult: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      headers: [
        { text: 'Status', value: 'actions', sortable: false },
        { text: '変更申請', value: 'changeRequest', sortable: false },
        { text: '代理店名', value: 'agencyName' },
        { text: '名称', value: 'name' },
        { text: 'マージン率', value: 'marginValue' },
        { text: '使用可能期間', value: 'dateRange' },
        { text: 'メモ', value: 'memo' },
        { text: '備考', sortable: false },
        { text: '詳細', value: 'detail', sortable: false },
      ],
      statusFilterItems: [
        { text: 'すべて', value: '' },
        { text: '承認済', value: 'approved' },
        { text: '承認待ち', value: 'waiting' },
        { text: '却下', value: 'rejected' },
        { text: 'キャンセル', value: 'cancel' },
      ],
      selectedStatusFilter: '',
      filterKeyword: '',
      showNewItem: false,
      isActiveLatestRequestModal: false,
      isActiveDetailModal: false,
      isActiveEditModal: false,
      isActiveCreateModal: false,
      currentItem: {},
    }
  },
  computed: {
    confirmModalMessage() {
      const targetName = this.currentItem.name
      const changeTo = this.currentItem.isStatusActive ? '無効' : '有効'
      return targetName + 'を' + changeTo + `に切り替えます。\nよろしいですか？`
    },
    agencyMarginList() {
      return this.searchResult.items.filter(
        item => !item.isNew || this.showNewItem,
      )
    },
  },
  methods: {
    async openConfirmModal(item) {
      this.currentItem = item
      const result = await this.$confirm(undefined, {
        body: this.confirmModalMessage,
      })
      if (result) {
        console.log('return true')
        console.log(
          'change from ' +
            this.currentItem.isStatusActive +
            ' to ' +
            !this.currentItem.isStatusActive,
        )
        // this.$store.dispatch(actions.RESET_TARGET_GROUP)
      }
    },
    openEditModal(item) {
      this.currentItem = item
      this.isActiveEditModal = true
    },
    openCreateModal() {
      this.isActiveCreateModal = true
    },
    openDetailModal(item) {
      this.currentItem = item
      this.isActiveDetailModal = true
    },
    openLatestRequestDetailModal(item) {
      this.currentItem = item
      this.isActiveLatestRequestModal = true
    },
    pagination(event) {
      console.log('WIP Pagination')
      console.log(event)
    },
  },
}
</script>

<style scoped>
.v-input--switch >>> .v-messages {
  display: none;
}
.not-passed-record {
  opacity: 0.25;
}
.memo-area {
  max-width: 300px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
